import { Primary } from '@cinch-labs/design-system'
import { BaseComponent } from '@cinch-nx/data-storyblok'
import styles from './navigation-button.module.css'
import { useNavigationButtonTracking } from './navigation-button.tracking'

export interface NavigationButtonProps extends BaseComponent {
  component: 'Button'
  text: string
  url: string
}

export const NavigationButton: React.FC<NavigationButtonProps> = (
  props: NavigationButtonProps,
) => {
  const trackingEvents = useNavigationButtonTracking()

  const handleOnClick = () => {
    trackingEvents.onNavigationButtonClick()
  }

  return (
    <section className={styles.container}>
      <Primary href={props.url} element="a" onClick={handleOnClick}>
        {props.text}
      </Primary>
    </section>
  )
}
